import React, { useEffect } from 'react';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import iconSelected from '../../../../assets/img/markers/marker-icon-red.png';
import iconResidence from '../../../../assets/img/markers/marker-icon-orange.png';
import Installer from '../../../classes/installer';
import { useTranslation } from 'react-i18next';
import { useStore } from 'store';
import SicuriProtettiServices from 'js/data/sicuri-protetti-services';

const DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconAnchor: [12, 41],
    popupAnchor: [0, -30],
});

const selIcon = L.icon({
    iconUrl: iconSelected,
    shadowUrl: iconShadow,
    iconAnchor: [12, 41],
    popupAnchor: [0, -30],
});

const resIcon = L.icon({
    iconUrl: iconResidence,
    shadowUrl: iconShadow,
    iconAnchor: [12, 41],
    popupAnchor: [0, -30],
});

L.Marker.prototype.options.icon = DefaultIcon;

interface IProps {
    data: Installer;
    installerSel: (installer: Installer) => void;
}

const InstallerSearchMapLeafletForm = (props: IProps) => {
    const { t } = useTranslation();
    const setLoading = useStore((state) => state.setLoading);

    useEffect(() => {
        const loadMap = async () => {
            setLoading(true);
            const installers = await SicuriProtettiServices.getInstallers();
            let zoom = 12;
            let center = props.data.installerId === undefined ? props.data.residenceGeoCoord : props.data.geoCoord;
            //Se non si trovano le coordinate il centro sarà Roma con visibile tutta Italia
            if (!center) {
                center = [41.9109, 12.4818];
                zoom = 7;
            }
            const map = L.map('map', { minZoom: 5 }).setView([center![0], center![1]], zoom);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

            if (props.data.residenceGeoCoord?.length === 2) {
                const residence = L.marker([props.data.residenceGeoCoord![0], props.data.residenceGeoCoord![1]])
                    .addTo(map)
                    .setIcon(resIcon)
                    .bindPopup('<strong>' + t('commonClass.resIsHere') + '</strong><br>');
                if (props.data.installerId === undefined) residence.openPopup();
            }

            const markers = L.markerClusterGroup();
            let selMarker;
            installers.forEach((installer) => {
                const marker = L.marker([installer.additionalData[5], installer.additionalData[6]], { title: installer.label })
                    .bindPopup(
                        '<strong>' +
                            installer.label +
                            '</strong><br>' +
                            installer.additionalData[1] +
                            ', ' +
                            installer.additionalData[2] +
                            ' - ' +
                            installer.additionalData[0] +
                            ' (' +
                            installer.additionalData[4] +
                            ') ' +
                            installer.additionalData[3]
                    )
                    .on('click', () => {
                        marker.setIcon(selIcon);
                        marker.openPopup();
                        props.installerSel(
                            new Installer(
                                installer.value,
                                installer.label,
                                installer.additionalData[1] +
                                    ', ' +
                                    installer.additionalData[2] +
                                    ' - ' +
                                    installer.additionalData[0] +
                                    ' (' +
                                    installer.additionalData[4] +
                                    ') ' +
                                    installer.additionalData[3],
                                (
                                    <>
                                        <strong>{t('customerClass.cellular')} : </strong>
                                        {installer.additionalData[7] === '' ? (
                                            <i>({t('commonClass.notAvailable')})</i>
                                        ) : (
                                            installer.additionalData[7]
                                        )}
                                        <br />
                                        <strong> {t('customerClass.landlinePhone')} : </strong>
                                        {installer.additionalData[8] === '' ? (
                                            <i>({t('commonClass.notAvailable')})</i>
                                        ) : (
                                            installer.additionalData[8]
                                        )}
                                        <br />
                                        <strong>{t('customerClass.emailAddress')} : </strong>
                                        {installer.additionalData[10] === '' ? (
                                            <i>({t('commonClass.notAvailable')})</i>
                                        ) : (
                                            installer.additionalData[10]
                                        )}
                                        <br />
                                        <strong>{t('customerClass.fax')} : </strong>
                                        {installer.additionalData[9] === '' ? (
                                            <i>({t('commonClass.notAvailable')})</i>
                                        ) : (
                                            installer.additionalData[9]
                                        )}
                                    </>
                                ),
                                [installer.additionalData[5], installer.additionalData[6]]
                            )
                        );
                    })
                    .on('popupclose', () => {
                        props.installerSel(new Installer());
                        marker.setIcon(DefaultIcon);
                    });
                if (props.data.installerId === installer.value) {
                    marker.setIcon(selIcon);
                    selMarker = marker;
                }
                markers.addLayer(marker);
            });
            map.addLayer(markers);
            if (selMarker) {
                markers.zoomToShowLayer(selMarker, function () {
                    selMarker.openPopup();
                });
            }
            setLoading(false);
        };

        loadMap();
        // eslint-disable-next-line
    }, []);

    return <div id="map" className="map-center"></div>;
};

export default InstallerSearchMapLeafletForm;
